import React from 'react';
import { ToggleField } from '@bucketplace/commerce-admin-ui';

import {
  ColorPickerField,
  FormContent,
  InspectorFormProvider,
} from '../../components';
import { DocumentInspectorProps } from '../../types';
import { StickyTabProps } from './StickyTab';

export function StickyTabInspector({ value, onChange }: DocumentInspectorProps<StickyTabProps>) {
  return (
    <InspectorFormProvider value={value} onChange={onChange}>
      <FormContent
        header="탭 스크롤"
      >
        <ToggleField name="scrollable" />
      </FormContent>

      <FormContent
        header="배경 색상"
      >
        <ColorPickerField
          name="backgroundColor"
          width="100%"
        />
      </FormContent>

      <FormContent
        header="선택된 탭 색상"
      >
        <ColorPickerField
          name="selectedColor"
          width="100%"
        />
      </FormContent>

      <FormContent
        header="기본 탭 색상"
      >
        <ColorPickerField
          name="defaultColor"
          width="100%"
        />
      </FormContent>
    </InspectorFormProvider>
  );
}
